<template>
  <form class="custom-options" data-testid="bundle-options">
    <div v-for="option in product.bundle_options" :key="('bundleOption_' + option.option_id)">
      <product-bundle-option :is-not-changeable="isOptionNotChangeable(option)" :option="option" @option-changed="optionChanged" :error-messages="errorMessages" />
      <subscription v-if="getCurrentSelectedOptionVariantSku[option.option_id]" :option-id="option.option_id" :product-option="getCurrentSelectedOptionVariantSku" :product="product" />
    </div>
    <subscription-add-to-cart :disabled="isSubscription.length > 0 ? (!IsAllPropsSelected || !isStartingNumberSelected) : !IsAllPropsSelected" :product="product" />
  </form>
</template>

<script>
import { ProductBundleOptions } from '@vue-storefront/core/modules/catalog/components/ProductBundleOptions.ts'
import ProductBundleOption from './ProductBundleOption'
import Subscription from 'theme/components/core/Subscription'
import SubscriptionAddToCart from 'theme/components/core/SubscriptionAddToCart'
import { getBundleOptionsValues, getSelectedBundleOptions } from '@vue-storefront/core/modules/catalog/helpers/bundleOptions'
import isEqual from 'lodash-es/isEqual'

export default {
  mixins: [ProductBundleOptions],
  components: {
    ProductBundleOption,
    Subscription,
    SubscriptionAddToCart
  },
  data () {
    return {
      lastCalledSkus: []
    }
  },
  watch: {
    // todo: find a way to call only when all option will be selected in background
    selectedBundleOptions: function (newVal, oldVal) {
      if (newVal.length === oldVal.length) {
        this.loadCurrentCustomOptions()
      }
    }
  },
  beforeMount () {
    this.loadCurrentCustomOptions()
  },
  computed: {
    isSubscription () {
      return this.product.bundle_options.map(x => this.getCurrentSelectedOptionVariantSku[x.option_id]).filter(x => x)
    },
    IsAllPropsSelected () {
      let bundleRequiredIds = this.product.bundle_options.filter(option => option.required).map(option => option.option_id.toString())
      let bundleSelectedIds = Object.keys(this.product.product_option.extension_attributes.bundle_options)
      return bundleRequiredIds.every(val => bundleSelectedIds.indexOf(val) >= 0)
    },
    isStartingNumberSelected () {
      return this.product.product_option.extension_attributes.starting_numbers
        ? this.isSubscription.length === this.product.product_option.extension_attributes.starting_numbers.length
        : false
    },
    selectedBundleOptions () {
      return getSelectedBundleOptions(this.product, 'product_option.extension_attributes.bundle_options')
    },
    getCurrentSubscriptionOptionSku () {
      let selectedSubscriptionOptions = {}
      const allBundeOptions = this.product.bundle_options || []
      let bundleOptionsValues = getBundleOptionsValues(this.selectedBundleOptions, allBundeOptions)
      let subscriptionOption = bundleOptionsValues.filter(option => option.product && option.product.type_id === 'subscription')
      subscriptionOption.forEach(option => { selectedSubscriptionOptions[option.id] = { sku: option.sku, product_id: option.product.id } })
      return selectedSubscriptionOptions
    },
    getCurrentSelectedOptionVariantSku () {
      let currentSelectedObject = {}
      this.product.bundle_options.forEach(option => {
        let currentSelectedOption = this.selectedBundleOptions.find(opt => opt.option_id === option.option_id)
        let currentSelectedOptionVariantId = currentSelectedOption && currentSelectedOption.option_selections[0]
        currentSelectedObject[option.option_id] = this.getCurrentSubscriptionOptionSku[currentSelectedOptionVariantId]
      })
      return currentSelectedObject
    }
  },
  methods: {
    isOptionNotChangeable (option) {
      const { product_links, required } = option
      return product_links.length === 1 && required
    },
    loadCurrentCustomOptions () {
      let skus = Object.values(this.getCurrentSubscriptionOptionSku).map(option => option.sku)
      if (skus && skus.length) {
        this.$store.dispatch('subscription-product/load', { skus: skus })
      }
      this.lastCalledSkus = skus
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
